import * as React from "react";
function SvgDiscQuestion(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <path d="M12 0a12 12 0 1012 12A12 12 0 0012 0zm1.07 18.59a1.57 1.57 0 01-1.13.4 1.58 1.58 0 01-1.14-.39 1.47 1.47 0 01-.41-1.11 1.47 1.47 0 01.4-1.11 1.57 1.57 0 011.15-.38 1.55 1.55 0 011.13.39 1.43 1.43 0 01.4 1.1 1.47 1.47 0 01-.4 1.1zm2.9-8a6.6 6.6 0 01-1.67 1.58 4.75 4.75 0 00-1.07.95A1.45 1.45 0 0013 14v.53h-2.32v-.65a2.89 2.89 0 01.32-1.51A4.76 4.76 0 0112.35 11a5.2 5.2 0 001.22-1 1.53 1.53 0 00.3-.92 1 1 0 00-.43-.87 2 2 0 00-1.17-.3 6.84 6.84 0 00-3 .86l-1-1.93a8.42 8.42 0 014.16-1.09 4.42 4.42 0 012.88.87 2.84 2.84 0 011.07 2.32 3.13 3.13 0 01-.38 1.64z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDiscQuestion);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
